import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'

interface AmbassadorHeroProps {
  data: {
    readonly tag: string
    readonly title: string
    readonly description: readonly string[]
    readonly buttonText: string
    readonly href: string
    readonly image: string
  }
}

export const AmbassadorHero = ({ data }: AmbassadorHeroProps) => {
  return (
    <div className='mb-10 flex flex-col items-center justify-between gap-6 md:mb-20 md:gap-20 lg:flex-row'>
      <div className='flex w-full flex-1 flex-col items-start'>
        <div className='mb-1 flex items-center gap-2 font-criteria text-sm font-medium uppercase italic tracking-wider text-[#A3BF00] md:mb-2 md:text-base 2xl:text-lg'>
          <Image
            src={ImageHelper.getN7ImageUrl(
              '/image/2026/03/23/black_-_symbol.png'
            )}
            alt={data.tag}
            width={24}
            height={24}
          />
          <span>{data.tag}</span>
        </div>
        <h3 className='mb-3 font-criteria text-3xl font-medium uppercase italic !leading-normal text-[#111111] md:mb-6 md:text-4xl 2xl:text-[44px]'>
          {data.title}
        </h3>
        <div className='mb-8 flex flex-col gap-2 text-sm leading-relaxed text-[#333333] md:text-lg'>
          {data.description.map((p: string, i: number) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <Link href={data.href} target='_blank'>
          <Button variant='black' size='large'>
            {data.buttonText}
          </Button>
        </Link>
      </div>
      <div className='w-full flex-1'>
        <Image
          src={ImageHelper.getN7ImageUrl(data.image)}
          alt={data.tag}
          width={1000}
          height={1000}
          className='h-auto w-full rounded-[16px] object-cover shadow-lg md:rounded-[24px]'
        />
      </div>
    </div>
  )
}
